import { render, staticRenderFns } from "./RegisterJWT.vue?vue&type=template&id=f70191ea"
import script from "./RegisterJWT.vue?vue&type=script&lang=js"
export * from "./RegisterJWT.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports